/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Translation } from "react-i18next";
import { proxyErrorStyle } from "../../function/proxyErrorStyle";
import { proxyErrorText } from "../../function/proxyErrorText";
import RegionWrap from "./RegionWrap";
import { isHK } from "../../function/isHK";
import { hasCity } from "../../function/hasCity";

class AddressFrom extends Component {
  hasCityAndState = () => {
    // 有縣市也有城市 ex.香港
    let ap;
    const { places } = this.props;
    if (places.items) {
      places.items.every(data => {
        if (data.hasOwnProperty("subitems")) {
          ap = true;
        } else {
          ap = false;
        }
        return ap;
      });
    } else {
      ap = false;
    }
    return ap;
  };

  hasCityNoState = () => {
    // 有縣市但沒有城市 ex.美國
    let ap;
    const { places } = this.props;
    if (places.items) {
      places.items.every(data => {
        if (data.hasOwnProperty("subitems")) {
          ap = false;
        } else {
          ap = true;
        }
        return ap;
      });
    } else {
      ap = false;
    }
    return ap;
  };

  render() {
    const {
      deliveryOption,
      handleDeliveryChange,
      places,
      cancelEditAddress,
      saveAdd
    } = this.props;

    return (
      <div className="delivery_newAddress_wrap">
        <Translation>
          {t => (
            <div className="subtitle subtitle_sect">
              {t("checkout.shippingAddress")}
            </div>
          )}
        </Translation>
        <div className="delivery_addressForm_wrap">
          <div className="row no-gutters with-gaps">
            <div className="col-12 col-md-6 clearfix">
              <div className="narrowerInput_wrap">
                <p>
                  <select
                    id="delivery_customerTitle"
                    name="delivery_customerTitle"
                    required
                    value={deliveryOption.delivery_customerTitle.value}
                    onChange={e => handleDeliveryChange(e)}
                    className={proxyErrorStyle(
                      deliveryOption.delivery_customerTitle.error
                    )}
                  >
                    <Translation>
                      {t => (
                        <>
                          <option value="">{t("checkout.title")}</option>
                          <option value="03">{t("checkout.ms")}</option>
                          <option value="01">{t("checkout.mr")}</option>
                          <option value="02">{t("checkout.miss")}</option>
                        </>
                      )}
                    </Translation>
                  </select>
                  {proxyErrorText(deliveryOption.delivery_customerTitle.error)}
                </p>
              </div>
              <div className="widerInput_wrap">
                <p>
                  <Translation>
                    {t => (
                      <input
                        type="text"
                        id="delivery_customerName"
                        name="delivery_customerName"
                        placeholder={t("checkout.name")}
                        required
                        value={deliveryOption.delivery_customerName.value}
                        onChange={e => handleDeliveryChange(e)}
                        className={proxyErrorStyle(
                          deliveryOption.delivery_customerName.error
                        )}
                      />
                    )}
                  </Translation>
                  {proxyErrorText(deliveryOption.delivery_customerName.error)}
                </p>
              </div>
            </div>
            <div className="col-12 col-md-6 clearfix">
              <div className="narrowerInput_wrap">
                <p>
                  <select
                    id="delivery_phoneCode"
                    name="delivery_phoneCode"
                    className="narrowerInput"
                    required
                    value={deliveryOption.delivery_phoneCode.value}
                    onChange={e => handleDeliveryChange(e)}
                  >
                    <option value="852">+852</option>
                    <option value="86">+86</option>
                    <option value="886">+886</option>
                    <option value="853">+853</option>
                    <option value="1">+1</option>
                    <option value="1242">+1242</option>
                    <option value="1246">+1246</option>
                    <option value="1264">+1264</option>
                    <option value="1268">+1268</option>
                    <option value="1345">+1345</option>
                    <option value="1441">+1441</option>
                    <option value="1664">+1664</option>
                    <option value="1670">+1670</option>
                    <option value="1671">+1671</option>
                    <option value="1758">+1758</option>
                    <option value="1784">+1784</option>
                    <option value="1787">+1787</option>
                    <option value="1809">+1809</option>
                    <option value="1876">+1876</option>
                    <option value="1890">+1890</option>
                    <option value="20">+20</option>
                    <option value="212">+212</option>
                    <option value="213">+213</option>
                    <option value="216">+216</option>
                    <option value="218">+218</option>
                    <option value="220">+220</option>
                    <option value="221">+221</option>
                    <option value="223">+223</option>
                    <option value="224">+224</option>
                    <option value="225">+225</option>
                    <option value="226">+226</option>
                    <option value="227">+227</option>
                    <option value="228">+228</option>
                    <option value="229">+229</option>
                    <option value="230">+230</option>
                    <option value="231">+231</option>
                    <option value="232">+232</option>
                    <option value="233">+233</option>
                    <option value="234">+234</option>
                    <option value="235">+235</option>
                    <option value="236">+236</option>
                    <option value="237">+237</option>
                    <option value="239">+239</option>
                    <option value="241">+241</option>
                    <option value="242">+242</option>
                    <option value="243">+243</option>
                    <option value="244">+244</option>
                    <option value="247">+247</option>
                    <option value="248">+248</option>
                    <option value="249">+249</option>
                    <option value="250">+250</option>
                    <option value="251">+251</option>
                    <option value="252">+252</option>
                    <option value="253">+253</option>
                    <option value="254">+254</option>
                    <option value="255">+255</option>
                    <option value="256">+256</option>
                    <option value="257">+257</option>
                    <option value="258">+258</option>
                    <option value="260">+260</option>
                    <option value="261">+261</option>
                    <option value="262">+262</option>
                    <option value="263">+263</option>
                    <option value="264">+264</option>
                    <option value="265">+265</option>
                    <option value="266">+266</option>
                    <option value="267">+267</option>
                    <option value="268">+268</option>
                    <option value="269">+269</option>
                    <option value="27">+27</option>
                    <option value="30">+30</option>
                    <option value="31">+31</option>
                    <option value="32">+32</option>
                    <option value="33">+33</option>
                    <option value="331">+331</option>
                    <option value="34">+34</option>
                    <option value="350">+350</option>
                    <option value="351">+351</option>
                    <option value="352">+352</option>
                    <option value="353">+353</option>
                    <option value="354">+354</option>
                    <option value="355">+355</option>
                    <option value="356">+356</option>
                    <option value="357">+357</option>
                    <option value="358">+358</option>
                    <option value="359">+359</option>
                    <option value="36">+36</option>
                    <option value="370">+370</option>
                    <option value="371">+371</option>
                    <option value="372">+372</option>
                    <option value="373">+373</option>
                    <option value="374">+374</option>
                    <option value="375">+375</option>
                    <option value="376">+376</option>
                    <option value="377">+377</option>
                    <option value="378">+378</option>
                    <option value="380">+380</option>
                    <option value="381">+381</option>
                    <option value="386">+386</option>
                    <option value="39">+39</option>
                    <option value="40">+40</option>
                    <option value="41">+41</option>
                    <option value="420">+420</option>
                    <option value="421">+421</option>
                    <option value="423">+423</option>
                    <option value="43">+43</option>
                    <option value="44">+44</option>
                    <option value="45">+45</option>
                    <option value="46">+46</option>
                    <option value="47">+47</option>
                    <option value="48">+48</option>
                    <option value="49">+49</option>
                    <option value="501">+501</option>
                    <option value="502">+502</option>
                    <option value="503">+503</option>
                    <option value="504">+504</option>
                    <option value="505">+505</option>
                    <option value="506">+506</option>
                    <option value="507">+507</option>
                    <option value="509">+509</option>
                    <option value="51">+51</option>
                    <option value="52">+52</option>
                    <option value="53">+53</option>
                    <option value="54">+54</option>
                    <option value="55">+55</option>
                    <option value="56">+56</option>
                    <option value="57">+57</option>
                    <option value="58">+58</option>
                    <option value="591">+591</option>
                    <option value="592">+592</option>
                    <option value="593">+593</option>
                    <option value="594">+594</option>
                    <option value="595">+595</option>
                    <option value="596">+596</option>
                    <option value="597">+597</option>
                    <option value="598">+598</option>
                    <option value="599">+599</option>
                    <option value="60">+60</option>
                    <option value="61">+61</option>
                    <option value="62">+62</option>
                    <option value="63">+63</option>
                    <option value="64">+64</option>
                    <option value="65">+65</option>
                    <option value="66">+66</option>
                    <option value="673">+673</option>
                    <option value="674">+674</option>
                    <option value="675">+675</option>
                    <option value="676">+676</option>
                    <option value="677">+677</option>
                    <option value="678">+678</option>
                    <option value="679">+679</option>
                    <option value="682">+682</option>
                    <option value="684">+684</option>
                    <option value="685">+685</option>
                    <option value="686">+686</option>
                    <option value="689">+689</option>
                    <option value="7">+7</option>
                    <option value="81">+81</option>
                    <option value="82">+82</option>
                    <option value="84">+84</option>
                    <option value="850">+850</option>
                    <option value="855">+855</option>
                    <option value="856">+856</option>
                    <option value="880">+880</option>
                    <option value="90">+90</option>
                    <option value="91">+91</option>
                    <option value="92">+92</option>
                    <option value="93">+93</option>
                    <option value="94">+94</option>
                    <option value="95">+95</option>
                    <option value="960">+960</option>
                    <option value="961">+961</option>
                    <option value="962">+962</option>
                    <option value="963">+963</option>
                    <option value="964">+964</option>
                    <option value="965">+965</option>
                    <option value="966">+966</option>
                    <option value="967">+967</option>
                    <option value="968">+968</option>
                    <option value="971">+971</option>
                    <option value="972">+972</option>
                    <option value="973">+973</option>
                    <option value="974">+974</option>
                    <option value="976">+976</option>
                    <option value="977">+977</option>
                    <option value="98">+98</option>
                    <option value="992">+992</option>
                    <option value="993">+993</option>
                    <option value="994">+994</option>
                    <option value="995">+995</option>
                  </select>
                </p>
              </div>
              <div className="widerInput_wrap">
                <p>
                  <Translation>
                    {t => (
                      <input
                        type="text"
                        id="delivery_phoneNo"
                        name="delivery_phoneNo"
                        placeholder={t("checkout.phone")}
                        required
                        value={deliveryOption.delivery_phoneNo.value}
                        onChange={e => handleDeliveryChange(e)}
                        className={proxyErrorStyle(
                          deliveryOption.delivery_phoneNo.error
                        )}
                      />
                    )}
                  </Translation>
                  {proxyErrorText(deliveryOption.delivery_phoneNo.error)}
                </p>
              </div>
            </div>
          </div>
          <div className="row no-gutters with-gaps">
            <div className="col-12 col-md-6">
              <p>
                <select
                  id="delivery_area"
                  name="delivery_area"
                  className={proxyErrorStyle(
                    deliveryOption.delivery_area.error,
                    "narrowerInput"
                  )}
                  required
                  value={deliveryOption.delivery_area.value}
                  onChange={e => handleDeliveryChange(e)}
                >
                  <Translation>
                    {t => (
                      <option value="">{t("checkout.chooseCountry")}</option>
                    )}
                  </Translation>
                  <RegionWrap />
                </select>
                {proxyErrorText(deliveryOption.delivery_area.error)}
              </p>
            </div>
          </div>
          <div className="row no-gutters with-gaps">
            <div className="col-12 col-md-6">
              <p>
                {places.items &&
                places.items.length > 0 &&
                this.hasCityAndState() ? (
                  <select
                    id="delivery_district"
                    name="delivery_district"
                    className={proxyErrorStyle(
                      deliveryOption.delivery_district.error,
                      "narrowerInput"
                    )}
                    required
                    value={deliveryOption.delivery_district.value}
                    onChange={e => handleDeliveryChange(e)}
                  >
                    {isHK(deliveryOption.delivery_area.value) ? (
                      <Translation>
                        {t => <option value="">{t("checkout.stateHK")}</option>}
                      </Translation>
                    ) : (
                      <Translation>
                        {t => <option value="">{t("checkout.state")}</option>}
                      </Translation>
                    )}
                    {places.items &&
                      places.items.length > 0 &&
                      places.items.map((area, index) => (
                        <option value={area.name} key={index}>
                          {area.name}
                        </option>
                      ))}
                  </select>
                ) : this.hasCityNoState() ? (
                  <select
                    id="delivery_district"
                    name="delivery_district"
                    className={proxyErrorStyle(
                      deliveryOption.delivery_district.error,
                      "narrowerInput"
                    )}
                    required
                    value={deliveryOption.delivery_district.value}
                    onChange={e => handleDeliveryChange(e)}
                  >
                    {isHK(deliveryOption.delivery_area.value) ? (
                      <Translation>
                        {t => <option value="">{t("checkout.stateHK")}</option>}
                      </Translation>
                    ) : (
                      <Translation>
                        {t => <option value="">{t("checkout.state")}</option>}
                      </Translation>
                    )}
                    {places.items &&
                      places.items.length > 0 &&
                      places.items.map((area, index) => (
                        <option value={area.name} key={index}>
                          {area.name}
                        </option>
                      ))}
                  </select>
                ) : (
                  <Translation>
                    {t => (
                      <input
                        type="text"
                        id="delivery_district"
                        name="delivery_district"
                        placeholder={t("checkout.state")}
                        required
                        value={deliveryOption.delivery_district.value}
                        onChange={e => handleDeliveryChange(e)}
                        className={proxyErrorStyle(
                          deliveryOption.delivery_district.error
                        )}
                      />
                    )}
                  </Translation>
                )}
                {places.items && places.items.length > 0
                  ? proxyErrorText(deliveryOption.delivery_district.error)
                  : proxyErrorText(deliveryOption.delivery_district.error)}
              </p>
            </div>
          </div>

          <div className="row no-gutters with-gaps">
            <div className="col-12 col-md-6">
              {/* 當國家為香港時不顯示此區域，其餘都顯示為城市 */}
              {hasCity(places, deliveryOption) ||
              deliveryOption.delivery_area.value === "HK" ||
              this.hasCityNoState() ? (
                this.hasCityAndState() ? null : (
                  <p>
                    <Translation>
                      {t => (
                        <input
                          type="text"
                          id="delivery_city"
                          name="delivery_city"
                          placeholder={
                            isHK(deliveryOption.delivery_area.value)
                              ? t("checkout.cityHK")
                              : t("checkout.city")
                          }
                          required
                          value={deliveryOption.delivery_city.value}
                          onChange={e => handleDeliveryChange(e)}
                          className={proxyErrorStyle(
                            deliveryOption.delivery_city.error
                          )}
                        />
                      )}
                    </Translation>
                    {places.items && places.items.length > 0
                      ? proxyErrorText(deliveryOption.delivery_city.error)
                      : proxyErrorText(deliveryOption.delivery_city.error)}
                  </p>
                )
              ) : (
                <p>
                  <Translation>
                    {t => (
                      <input
                        type="text"
                        id="delivery_city"
                        name="delivery_city"
                        placeholder={
                          isHK(deliveryOption.delivery_area.value)
                            ? t("checkout.cityHK")
                            : t("checkout.city")
                        }
                        required
                        value={deliveryOption.delivery_city.value}
                        onChange={e => handleDeliveryChange(e)}
                        className={proxyErrorStyle(
                          deliveryOption.delivery_city.error
                        )}
                      />
                    )}
                  </Translation>
                  {places.items && places.items.length > 0
                    ? proxyErrorText(deliveryOption.delivery_city.error)
                    : proxyErrorText(deliveryOption.delivery_city.error)}
                </p>
              )}
            </div>
          </div>

          {/* 選擇香港時的樣式 */}
          {hasCity(places, deliveryOption) ||
          deliveryOption.delivery_area.value === "HK" ||
          this.hasCityNoState() ? (
            this.hasCityAndState() ? (
              <div className="row no-gutters with-gaps">
                <div className="col-12 col-md-6">
                  <p>
                    <select
                      id="delivery_city"
                      name="delivery_city"
                      className={proxyErrorStyle(
                        deliveryOption.delivery_city.error,
                        "narrowerInput"
                      )}
                      required
                      value={deliveryOption.delivery_city.value}
                      onChange={e => handleDeliveryChange(e)}
                    >
                      {isHK(deliveryOption.delivery_area.value) ? (
                        <Translation>
                          {t => (
                            <option value="">{t("checkout.cityHK")}</option>
                          )}
                        </Translation>
                      ) : (
                        <Translation>
                          {t => <option value="">{t("checkout.city")}</option>}
                        </Translation>
                      )}

                      {places.items &&
                        places.items.length > 0 &&
                        places.items.map((area, index) => {
                          if (
                            area.name === deliveryOption.delivery_district.value
                          ) {
                            return (
                              area.subitems &&
                              area.subitems.length > 0 &&
                              area.subitems.map((district, index) => (
                                <option value={district.name} key={index}>
                                  {district.name}
                                </option>
                              ))
                            );
                          }
                          return null;
                        })}
                    </select>
                    {places.items && places.items.length > 0
                      ? proxyErrorText(deliveryOption.delivery_city.error)
                      : proxyErrorText(deliveryOption.delivery_city.error)}
                  </p>
                </div>
              </div>
            ) : null
          ) : null}

          <div className="row no-gutters with-gaps">
            <div className="col-12 col-md-6">
              {!isHK(deliveryOption.delivery_area.value) && (
                <p>
                  <Translation>
                    {t => (
                      <input
                        type="text"
                        id="delivery_postcode"
                        name="delivery_postcode"
                        placeholder={t("checkout.postcode")}
                        required
                        value={deliveryOption.delivery_postcode.value}
                        onChange={e => handleDeliveryChange(e)}
                        className={proxyErrorStyle(
                          deliveryOption.delivery_postcode.error
                        )}
                      />
                    )}
                  </Translation>
                  {proxyErrorText(deliveryOption.delivery_postcode.error)}
                </p>
              )}
            </div>
          </div>

          <p>
            <Translation>
              {t => (
                <input
                  type="text"
                  id="delivery_addressLine1"
                  name="delivery_addressLine1"
                  placeholder={t("checkout.address1")}
                  required
                  value={deliveryOption.delivery_addressLine1.value}
                  onChange={e => handleDeliveryChange(e)}
                  className={proxyErrorStyle(
                    deliveryOption.delivery_addressLine1.error
                  )}
                />
              )}
            </Translation>
            {proxyErrorText(deliveryOption.delivery_addressLine1.error)}
          </p>
          <p>
            <Translation>
              {t => (
                <input
                  type="text"
                  id="delivery_addressLine2"
                  name="delivery_addressLine2"
                  placeholder={t("checkout.address2")}
                  value={
                    deliveryOption.delivery_addressLine2.value === null
                      ? ""
                      : deliveryOption.delivery_addressLine2.value
                  }
                  required
                  onChange={e => handleDeliveryChange(e)}
                />
              )}
            </Translation>
          </p>
        </div>
        <div className="buttons_wrap">
          <div>
            <Translation>
              {t => (
                <>
                  <a
                    id="cancelSaveAdd_btn"
                    className="blockBtn grey inline_block space"
                    // href="javascript:void(0)"
                    onClick={cancelEditAddress}
                  >
                    {t("checkout.cancel")}
                  </a>
                  <a id="saveAdd_btn" className="blockBtn space" onClick={saveAdd}>
                    {t("checkout.saveAddress")}
                  </a>
                </>
              )}
            </Translation>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddressFrom);
